module.exports = __webpack_public_path__ + "static/media/08B2.6d89a01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/08B2.png
// module id = 274
// module chunks = 0